import { z } from 'zod';

import { StrictAddress } from '../Address';
import { VerificationOfMortgagePurpose } from '../documents/VerificationOfMortgage';
import { Actor } from '../events';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const GenerateVerificationOfMortgageSideEffectContext = BaseLoanIdSideEffect.extend({
  actor: Actor, // borrower-requested vs lender-created have minor flow variations (ie one creates a task)
  purpose: VerificationOfMortgagePurpose,
  otherPurpose: z.string().optional(),
  recipientName: z.string(),
  companyName: z.string(),
  recipientAddress: StrictAddress,
});
export const GenerateVerificationOfMortgageSideEffect = GenerateVerificationOfMortgageSideEffectContext.extend({
  type: z.literal('generateVerificationOfMortgage'),
});
export type GenerateVerificationOfMortgageSideEffect = z.infer<typeof GenerateVerificationOfMortgageSideEffect>;
